<template>

    <div class="canvas::editor-admin-Gallery h-full w-full flex flex-col relative">

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200.26 68.42"
             class="absolute w-40 pointer-events-none -mr-4 arrow"
             v-if="canvasVersion.canvas_blocks.length == 0">
            <path d="M6.19,9.4Q4.9,7.87,3.62,6.3L5.18,5Q6.44,6.6,7.72,8.11Z"></path>
            <path
                d="M139.15,68.42q-2,0-4,0l0-2q4.09.08,8.16,0l0,2Q141.29,68.42,139.15,68.42ZM128,68.13c-2.75-.15-5.52-.35-8.22-.61l.19-2c2.68.25,5.42.45,8.14.6Zm22.65,0-.11-2c2.7-.14,5.44-.33,8.15-.58l.18,2C156.12,67.78,153.36,68,150.63,68.12ZM166,66.79l-.24-2c2.69-.32,5.41-.7,8.09-1.11l.31,2C171.48,66.09,168.73,66.47,166,66.79Zm-53.43-.08c-2.73-.36-5.47-.78-8.15-1.25l.35-2c2.64.47,5.36.88,8.06,1.24Zm68.69-2.25-.37-2c2.66-.49,5.35-1,8-1.62l.43,2C186.68,63.41,184,64,181.28,64.46Zm-83.92-.4c-2.68-.58-5.38-1.24-8-1.94l.52-1.93c2.6.69,5.27,1.34,7.93,1.92Zm-15-3.94c-2.63-.82-5.26-1.71-7.81-2.65l.69-1.88c2.53.93,5.12,1.81,7.72,2.62ZM67.87,54.84c-2.54-1.06-5.07-2.19-7.53-3.37l.86-1.8C63.63,50.83,66.13,52,68.64,53Zm-14-6.62c-2.41-1.29-4.82-2.66-7.17-4.07l1-1.71c2.32,1.4,4.71,2.75,7.08,4ZM40.62,40.27c-2.28-1.52-4.55-3.12-6.74-4.75l1.19-1.6c2.17,1.62,4.41,3.19,6.66,4.69ZM28.19,31.08c-2.11-1.73-4.22-3.54-6.25-5.38l1.34-1.48c2,1.82,4.09,3.61,6.18,5.31ZM16.69,20.75c-1.94-1.91-3.86-3.91-5.73-5.93l1.47-1.35c1.84,2,3.74,4,5.66,5.86Z"></path>
            <path d="M196.38,61.16l-.49-1.94q1.94-.49,3.85-1l.52,1.93Q198.33,60.67,196.38,61.16Z"></path>
            <polygon points="1.39 9.88 0 0 9.24 3.73 1.39 9.88"></polygon>
        </svg>

        <div class="h-full overflow-auto pt-4 pl-5">

            <div class="flex items-center">

                <div class="pr-4">
                    <h4 class="my-0">Blok toevoegen</h4>
                    <h6 class="mt-1 mb-5">Kies een blok uit één van de categorieën en sleep deze links op de pagina om toe te voegen.</h6>
                </div>

                <div class="relative z-0 inline-flex shadow-sm rounded-md ml-auto mr-5 categories">

                    <button
                        v-for="(category, key) in activeGalleryData"
                        :key="category.id"
                        class="-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                        :class="{ 'bg-indigo-50': activeCategory === category, 'rounded-r-md': key === Object.keys(activeGalleryData).length - 1, 'rounded-l-md': key === 0 }"
                        type="button"
                        @click="activeCategory = category">
                        {{ category.label }}
                    </button>

                </div>

            </div>

            <div class="mt-5 pr-5">

                <div class="" v-for="section in sections">

                    <div class="text-xl text-indigo-500 mb-5 text-center" v-if="Object.keys(sections).length > 1">{{ section.name === 'undefined' ? 'Geen categorie' : section.name }}</div>

                    <div class="blocks grid grid-cols-3 gap-6 pb-10">

                        <div class="flex hover:opacity-50 transition-all"
                             v-for="block in section.blocks">

                            <button
                                type="button"
                                class="col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200 h-80 w-full"
                                draggable="true"
                                :title="block.id"
                                @dragstart="onDragStart(block)"
                                @dragend="onDragEnd"
                                @click="addBlock(block)">

                                <div class="flex-1 flex flex-col px-2 py-5 mx-auto w-full">

                                    <div v-if="block.icon ? block.icon.original : false"
                                         class="h-32 flex items-center">

                                        <img :src="convertSvgToImageSrc(block.icon.original)"
                                             draggable="false"
                                             :title="block.id"
                                             class="h-full mx-auto"/>

                                    </div>

                                    <div v-else-if="block.icon"
                                         class="h-32 flex items-center">

                                        <img :src="block.icon"
                                             draggable="false"
                                             :title="block.id"/>

                                    </div>

                                    <div v-else-if="block.meta.icon"
                                         class="h-32 flex items-center relative icon">

                                        <svg xmlns="http://www.w3.org/2000/svg" width="457.361" height="457.361" viewBox="0 0 457.361 457.361">
                                            <g id="Group_37" data-name="Group 37" transform="translate(-1781 -3305)">
                                                <path id="Path_20" data-name="Path 20" d="M371.605,457.361H85.755A85.75,85.75,0,0,1,0,371.605V85.755A85.75,85.75,0,0,1,85.755,0h285.85a85.75,85.75,0,0,1,85.755,85.755v285.85A85.75,85.75,0,0,1,371.605,457.361Z" transform="translate(1781 3305)" fill="#d8d8d8"/>
                                            </g>
                                        </svg>

                                        <i :class="block.meta.icon" class="absolute left-0 right-0 text-4xl" />

                                    </div>

                                    <div v-else
                                         class="h-32 flex items-center">

                                        <img src="/vendor/galaxy/canvas/img/editor/admin/question-mark.svg"
                                             draggable="false"
                                             :title="block.id"
                                             class="h-full mx-auto"/>

                                    </div>


                                    <h3 class="mt-6 text-gray-900 text-base font-medium truncate w-full mx-auto"
                                        :title="block.meta.name">{{ block.meta.name }}</h3>

                                    <dl class="mt-1 flex-grow flex flex-col justify-between">
                                        <dt class="sr-only">Description</dt>
                                        <dd class="text-gray-400 text-sm mx-6 description"
                                            :title="block.meta.description">{{ block.meta.description }}
                                        </dd>
                                        <dt class="sr-only">Role</dt>
                                        <dd class="mt-3">
                                            <span v-for="(color, text) in block.meta.tags"
                                                  :class="color"
                                                  class="px-2 mx-1 py-1 text-xs font-medium text-black rounded-full">
                                                {{ text }}
                                            </span>
                                        </dd>
                                    </dl>
                                </div>

                            </button>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

export default {

    props: {
        canvasVersion: Object,
        canvasBlocksGalleryData: Array,
    },

    data()
    {
        return {
            activeCategory: this.canvasBlocksGalleryData[0],
        };
    },

    methods: {

        onDragStart(block)
        {
            this.$emit('onDraggingBlockId', block.id);
        },

        onDragEnd()
        {
            this.$emit('onDraggingBlockId', null);
        },

        addBlock(block)
        {
            this.$parent.$refs['canvasComponent'].$refs['iframe'].iframeApp.pageComponent.addBlock(block.id);
        },

        // @ugly and slow?
        convertSvgToImageSrc(svg)
        {
            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent((svg))));
        },

    },

    computed: {

        activeGalleryData()
        {
            // Filter out utils.
            return _.filter(this.canvasBlocksGalleryData, category => category.id != 'utils');
        },

        sections()
        {
            // Group the sections.
            let groupedSections = _.groupBy(this.sortedBlocks, 'meta.section');
            var sections = Object.keys(groupedSections).map(name=>({name, blocks: groupedSections[name]}));

            // Ensure that header sections is always on top and footer is always at the bottom.
            var headerKey;
            var footerKey;

            if((headerKey = _.findIndex(sections, {'name': 'Header'})) > -1) {
                let headerSection = _.pullAt(sections, headerKey)[0];
                sections.unshift(headerSection);
            }
            if((footerKey = _.findIndex(sections, {'name': 'Footer'})) > -1) {
                let footerSection = _.pullAt(sections, footerKey)[0];
                sections.push(footerSection);
            }

            return sections;
        },

        sortedBlocks()
        {
            return _.sortBy(this.activeCategory.blocks, block => block.id);
        },

    },

}

</script>

<style lang="scss">
.canvas\:\:editor-admin-Gallery {
    .blocks {
        button {
            svg {
                @apply h-full w-auto mx-auto;
            }
        }
    }
}
</style>

<style lang="scss" scoped>

.canvas\:\:editor-admin-Gallery {
    border-left: 1px solid #e2e8f0;

    .arrow {
        fill: #909090;
        right: calc(100% - 25px);
        top: 185px;
    }

    h6 {
        color: #90a4ae;
        font-weight: 300;
    }

    .blocks {

        button {
            transition: box-shadow .3s;

            &:active {
                border: 1px solid #edf2f7 !important;
            }

            &:hover {
                @apply shadow;
            }

            img {
                max-width: 100%;
                user-select: none;
                max-height: 100%;
                margin: auto;
            }

            .description {
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }

            .icon i {
                color: #646464;
            }
        }
    }

}

</style>
